import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Navbar.css";
import "./mediaCss.css";
import { Row } from "react-bootstrap";
import logo from "../../Images/logo/isbm-university.webp";
import { Carousel } from "react-bootstrap";
import MenubarMob from "../common/MenubarMob";
import mobilebanner1 from "../../Images/Banner/01-m.webp";
import mobilebanner2 from "../../Images/Banner/09-m.webp";
import mobilebanner3 from "../../Images/Banner/03-m.webp";
import mobilebanner4 from "../../Images/Banner/02-m.webp";
import mobilebanner5 from "../../Images/Banner/05-m.webp";
import mobilebanner6 from "../../Images/Banner/06-m.webp";
import mobilebanner7 from "../../Images/Banner/07-m.webp";
import mobilebanner8 from "../../Images/Banner/10-m.webp";

const BannerMob = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const divRef = useRef(null);
  const targetRef = useRef(null);
  const [width, setWidth] = useState(null);
  const [hoveredSchool, setHoveredSchool] = useState(null);
  const [courses, setCourses] = useState([]);
  const [schools, setSchools] = useState([]);

  // Consolidated size adjustment function
  const adjustSize = () => {
    if (divRef.current && targetRef.current) {
      const containerWidth = divRef.current.offsetWidth;
      targetRef.current.style.width = `${containerWidth}px`;
      setWidth(containerWidth);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const response = await axios.get(
          "https://isbmuniversity.edu.in/admin-portal/schoolsApi"
        );
        setSchools(response.data.data);
      } catch (error) {
        console.error("Error fetching schools:", error);
      }
    };

    fetchSchools();
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        if (hoveredSchool) {
          const response = await axios.get(
            `https://isbmuniversity.edu.in/admin-portal/coursesList${hoveredSchool}`
          );
          setCourses(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, [hoveredSchool]);

  const toggleNavbar = () => setIsOpen(!isOpen);

  const handleMouseEnter = () => {
    adjustSize();
  };

  const handleMouseLeave = () => {};

  const academicsCarousel = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <div>
      <MenubarMob />
      <Carousel className="abcd mobiles">
        <Carousel.Item key={1} interval={3000} data-pause="true">
          <img
            className="d-block w-100"
            src={mobilebanner1}
            alt="The Best in Campus Facilities and Resources"
          />
        </Carousel.Item>
        <Carousel.Item key={2} interval={3000} data-pause="true">
          <img
            className="d-block w-100"
            src={mobilebanner2}
            alt="International Opportunities"
          />
        </Carousel.Item>
        <Carousel.Item key={3} interval={3000} data-pause="true">
          <img
            className="d-block w-100"
            src={mobilebanner3}
            alt="Convocation Ceremony"
          />
        </Carousel.Item>
        <Carousel.Item key={4} interval={3000} data-pause="true">
          <img
            className="d-block w-100"
            src={mobilebanner4}
            alt="ISBM university Awarded by Honourable Dignitaries"
          />
        </Carousel.Item>
        <Carousel.Item key={5} interval={3000} data-pause="true">
          <img
            className="d-block w-100"
            src={mobilebanner5}
            alt="ISBM university Awarded by Honourable Dignitaries"
          />
        </Carousel.Item>
        <Carousel.Item key={6} interval={3000} data-pause="true">
          <img className="d-block w-100" src={mobilebanner6} alt="Awards" />
        </Carousel.Item>
        <Carousel.Item key={6} interval={3000} data-pause="true">
          <img className="d-block w-100" src={mobilebanner7} alt="Awards" />
        </Carousel.Item>
        <Carousel.Item key={6} interval={3000} data-pause="true">
          <img className="d-block w-100" src={mobilebanner8} alt="Awards" />
        </Carousel.Item>
      </Carousel>
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Cose"
          ></button>
        </div>
        <div className="offcanvas-body"></div>
      </div>
    </div>
  );
};

export default BannerMob;
